import { UseCases } from "@planzone/core";
import {
  Event,
  Identifiable,
  List,
  Milestone,
  Resource,
  Task,
} from "@planzone/dto";
import { Context, Roles } from "../types";

function isInTask({ uuid }: Identifiable<Resource>, task: Identifiable<Task>) {
  return (
    task.allocations &&
    !!task.allocations.find(({ resource }) => resource.uuid === uuid)
  );
}

function isInList(
  resource: Identifiable<Resource>,
  list: Identifiable<List>,
): boolean {
  return (
    !!(list.tasks || []).find((task) => isInTask(resource, task)) ||
    !!(list.subLists || []).find((subList) => isInList(resource, subList))
  );
}

function isInEvent(
  { uuid }: Identifiable<Resource>,
  event: Identifiable<Event>,
): boolean {
  return (
    !!event.participants &&
    !!event.participants.find((resource) => resource.uuid === uuid)
  );
}

function isInMilestone(
  { uuid }: Identifiable<Resource>,
  milestone: Identifiable<Milestone>,
): boolean {
  return true;
}

function isInDiscussion(resource: Identifiable<Resource>, context: Context) {
  return !!context.task
    ? isInTask(resource, context.task)
    : !!context.list
      ? isInList(resource, context.list)
      : !!context.event
        ? isInEvent(resource, context.event)
        : !!context.milestone
          ? isInMilestone(resource, context.milestone)
          : false;
}

function isOwnComment(resource: Identifiable<Resource>, context: Context) {
  return !!context.comment && context.comment.author.uuid === resource.uuid;
}

function updateFromComments(
  resource: Identifiable<Resource>,
  permissions: { [Key in UseCases]: Roles[] },
  context: Context,
): {
  [Key in UseCases]: Roles[];
} {
  return {
    ...permissions,
    [UseCases.removeComment]: isOwnComment(resource, context)
      ? [...permissions.removeComment, Roles.Worker]
      : permissions.removeComment,
    [UseCases.postComment]: isInDiscussion(resource, context)
      ? [...permissions.postComment, Roles.Worker]
      : permissions.postComment,
  };
}

export { updateFromComments };
